
import { SET_USER_LIST } from "../actions/getUserListAction";

const initialState = {
  userList: [],
};

const getUserListReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_LIST:
      return {
        ...state,
        userList: action.payload,
      };
    default:
      return state;
  }
};

export default getUserListReducer;
